import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Table, Select } from "antd";

const Option = Select.Option;

class TabelaProximasMobile extends Component {
    state = {
        filteredInfo: null,
        sortedInfo: null
    };

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter
        });
    };

    render() {
        let { sortedInfo, filteredInfo } = this.state;
        const { videoconferencias } = this.props;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};

        const columns = [
            {
                title: "Assunto",
                dataIndex: "assunto",
                key: "assunto"
            },
            {
                title: "",
                dataIndex: "controlos",
                key: "controlos"
            }
        ];

        return (
            <>
                <Table
                    columns={columns}
                    dataSource={videoconferencias}
                    pagination={false}
                    loading={this.props.loading}
                    onChange={this.props.handleTableChange}
                    rowClassName="clickeble-row"
                    onRow={(record, index) => {
                        return {
                            onClick: () => this.props.onRowClick(record.id)
                        };
                    }}
                    locale={{ emptyText: "Não existem dados!" }}
                />
            </>
        );
    }
}

export default withRouter(TabelaProximasMobile);
